<template>
    <div class='field-container'>
        <div v-if='label'>
            <label class='label' :id="id + '_label'" :for="id" v-html='label'></label><i v-if='mandatory' class="fas fa-asterisk mandatory"></i>
        </div>
        <div>
            <div ref='input_field' class='input-field'>
                <slot></slot>
            </div>

            <FieldError :errors='errors' :field_id='id'/>
        </div>
    </div>
</template>

<script>
 import FieldError from '@/ecom/components/fields/FieldError.vue';

export default{
    components :{FieldError},
    props : ['id', 'label', 'mandatory', 'errors'],
    data(){
        return{
            input_field : null,
        }
    },
    mounted() {
        this.input_field = this.$refs.input_field.children[0];

        if(this.input_field.classList.contains('typeahead-wrapper')){
            this.input_field = this.input_field.getElementsByTagName('input')[0];
        }

        this.input_field.setAttribute('id', this.id);
        this.input_field.setAttribute('ref', this.id);
    }
}
</script>

<style lang='scss'>


.field-container{
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
}

.label{
    font-size: 1rem;
    color: var(--black);
    font-weight: 600;
}

.mandatory{
    font-size: 0.4rem; 
    vertical-align: text-top;
    margin-top: 2px; 
    margin-left: 5px;
    color: #e03131;
}

.input-field>input, .input-field>select  {
    box-sizing: border-box; 
    height: 50px;
    border: 1px solid var(--black);
    padding: 0px 15px;
    font-size: 1rem;
    width: 100%;
    color: var(--black);
}

.input-field>input:focus{
     outline: red;
}

.input-field>textarea{
    box-sizing: border-box; 
    border: 1px solid var(--black);
    padding: 16px 15px;
    font-size: 1rem;
    color: var(--black);
    font-family: "Poppins", sans-serif;
}

.input-field>textarea:focus{
     outline: red;
}

</style>